/* global React, Button, Icon, toast */

const PF_HOUSEHOLD_INVITE_KEY = 'plumme-pending-household-invite';

const PlummeHouseholdInvite = {
  capture() {
    const params = new URLSearchParams(window.location.search || '');
    const inviteId = String(params.get('householdInvite') || '').trim();
    if (inviteId) {
      localStorage.setItem(PF_HOUSEHOLD_INVITE_KEY, inviteId);
      params.delete('householdInvite');
      const query = params.toString();
      window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash || ''}`);
    }
    return inviteId || localStorage.getItem(PF_HOUSEHOLD_INVITE_KEY) || '';
  },
  current() { return localStorage.getItem(PF_HOUSEHOLD_INVITE_KEY) || ''; },
  clear(inviteId) {
    if (!inviteId || this.current() === inviteId) localStorage.removeItem(PF_HOUSEHOLD_INVITE_KEY);
  },
};

PlummeHouseholdInvite.capture();

function PersonalFinanceHouseholdInviteGate({ backend, setClient, setRoute }) {
  const [state, setState] = React.useState({ incomingInvites: [] });
  const [busy, setBusy] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);
  const pendingId = PlummeHouseholdInvite.current();

  const refresh = React.useCallback(async () => {
    if (!backend?.user || !backend?.getPersonalFinanceHousehold) return;
    try {
      const result = await backend.getPersonalFinanceHousehold({});
      setState(result || { incomingInvites: [] });
    } catch (_) {
      setState({ incomingInvites: [] });
    } finally {
      setLoaded(true);
    }
  }, [backend?.user?.uid]);

  React.useEffect(() => { refresh(); }, [refresh]);
  React.useEffect(() => {
    const handler = () => refresh();
    window.addEventListener('plumme-private-created', handler);
    return () => window.removeEventListener('plumme-private-created', handler);
  }, [refresh]);

  const invites = state.incomingInvites || [];
  const invite = invites.find((entry) => entry.id === pendingId) || invites[0];
  if (!loaded || !invite) return null;

  const privateClient = (backend.memberships || []).find((entry) => entry.clientType === 'personal' || entry.privateEconomy === true);
  const respond = async (action) => {
    if (action === 'accept' && !privateClient) {
      localStorage.setItem(PF_HOUSEHOLD_INVITE_KEY, invite.id);
      window.showOnboarding?.('privat', { inviteId: invite.id });
      return;
    }
    setBusy(true);
    try {
      await backend.respondPersonalFinanceHouseholdInvite({ action, businessId: privateClient?.businessId, inviteId: invite.id });
      PlummeHouseholdInvite.clear(invite.id);
      toast(action === 'accept' ? 'Familieøkonomien er koblet sammen.' : 'Invitasjonen er avslått.', 'success');
      await refresh();
      if (action === 'accept' && privateClient?.businessId) {
        setClient?.(privateClient.businessId);
        setRoute?.('privatokonomi');
      }
    } catch (error) {
      toast(error?.message || 'Kunne ikke svare på invitasjonen.', 'error');
    } finally {
      setBusy(false);
    }
  };

  return <aside className="household-invite-global" role="status">
    <span className="household-invite-global__icon"><Icon name="users" size={20} /></span>
    <div className="grow"><div className="t-h3">{t('r1e.household.title')}</div><div className="t-sm muted">{t('r1e.household.body', { inviter: invite.invitedByEmail || t('r1e.household.defaultInviter') })}</div></div>
    <div className="row gap-8"><Button variant="ghost" size="sm" disabled={busy} onClick={() => respond('decline')}>{t('sharedText.fe.decline')}</Button><Button size="sm" disabled={busy} onClick={() => respond('accept')}>{privateClient ? 'Godta' : 'Opprett Privatøkonomi'}</Button></div>
  </aside>;
}

Object.assign(window, { PersonalFinanceHouseholdInviteGate, PlummeHouseholdInvite });
